/**
 * Resolve a course UUID for batch create/update from the selected teacher.
 * Teachers may expose course as an id, nested object, or course_name string.
 */
export function resolveCourseIdForTeacher(teacher, courses = []) {
  if (!teacher) return '';

  const directId =
    teacher.course_id ??
    teacher.assigned_course ??
    teacher.course?.course_id ??
    teacher.course?.id ??
    (typeof teacher.course === 'string' || typeof teacher.course === 'number'
      ? teacher.course
      : null);

  if (directId != null && String(directId).trim()) {
    return String(directId).trim();
  }

  const courseName =
    teacher.course_name ||
    teacher.assigned_course_name ||
    teacher.course?.course_name ||
    teacher.course?.name ||
    '';

  if (!courseName) return '';

  const normalized = String(courseName).trim().toLowerCase();
  const matched = courses.find((course) => {
    const name = (course?.course_name || course?.name || '').trim().toLowerCase();
    return name && name === normalized;
  });

  if (!matched) return '';

  const id = matched.course_id ?? matched.id;
  return id != null ? String(id).trim() : '';
}
